import React from 'react'

// Original sidebar vectors from Figma frame 217, Group 6510.
export default ({ color = '#9CA3B2' }) => (
  <svg width="20.0711" height="20.0711" viewBox="26 79 20.0711 20.0711" fill="none" aria-hidden="true">
    <path
      d="M30 91.071C30.1747 93.2036 31.8674 94.8963 34 95.071C31.8674 95.2458 30.1747 96.9385 30 99.071C29.8253 96.9385 28.1326 95.2458 26 95.071C28.1326 94.8963 29.8253 93.2036 30 91.071Z"
      fill={color}
    />
    <path
      d="M39 79C39.3089 82.7699 42.3012 85.7622 46.0711 86.0711C42.3012 86.38 39.3089 89.3723 39 93.1421C38.6911 89.3723 35.6988 86.38 31.9289 86.0711C35.6988 85.7622 38.6911 82.7699 39 79Z"
      fill={color}
    />
  </svg>
)
